import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const TokensContext = /*#__PURE__*/createContext(null);
export const useTokensContext = () => useContext(TokensContext);
export const TokensContextProvider = props => {
  return /*#__PURE__*/_jsx(TokensContext.Provider, {
    value: props.value,
    children: props.children
  });
};
//# sourceMappingURL=TokensContext.js.map